import { selectStpRates } from '@va/aaas/shared/selectors';
import { useTranslate } from '@va/localization';
import { TooltipWrapper } from '@va/ui/tooltips';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Counter } from '../counter';
import { AccountStpCounterContent } from './AccountStpCounterContent';
import { WebsiteStpCounterContent } from './WebsiteStpCounterContent';

export const StpCounter = () => {
  const translate = useTranslate();
  const stpRates = useSelector(selectStpRates);

  const isWebsiteInPool = useMemo(() => stpRates && stpRates.poolId, [stpRates]);

  const consumed = useMemo(() => {
    if (isWebsiteInPool) return stpRates.pool?.consumed ?? 0;

    return stpRates?.stpConsumed ?? 0;
  }, [isWebsiteInPool, stpRates.pool?.consumed, stpRates?.stpConsumed]);

  const total = useMemo(() => {
    if (isWebsiteInPool) return stpRates.pool?.limit ?? 0;

    return stpRates?.stpLimit ?? 0;
  }, [isWebsiteInPool, stpRates.pool?.limit, stpRates?.stpLimit]);

  const hasInfiniteCredits = useMemo(() => total === -1, [total]);

  return (
    <TooltipWrapper
      placement='bottom'
      useDefaultStyle={false}
      interactive
      disabled={!stpRates}
      content={isWebsiteInPool ? <AccountStpCounterContent /> : <WebsiteStpCounterContent />}
      tooltipClassNames='sm:w-full w-560px max-w-560px sm:px-3 bg-white'
      trigger='click'
    >
      <div>
        <Counter
          consumed={consumed}
          total={total}
          label={translate('pageHeader.creditsCounter.title')}
          hasInfiniteLimit={hasInfiniteCredits}
        />
      </div>
    </TooltipWrapper>
  );
};
